export default "__VITE_ASSET__ed95632f__"